// extracted by mini-css-extract-plugin
module.exports = {"label":"selected-label-module--label--2zBkX","text":"selected-label-module--text--19PVG","textItem":"selected-label-module--textItem--3v1v4"};